// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.order.OrderStatusHistoryResponse */
/* istanbul ignore next */
@GandalfModel
export class OrderStatusHistoryResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: Date })
	endDate!: Date | null;

	@GandalfProperty({ designType: Number })
	orderId!: number | null;

	@GandalfProperty({ designType: Number })
	orderOnHoldHistoryId!: number | null;

	@GandalfConstantDecorator(constants.OrderStatusCode)
	@GandalfProperty({ designType: constants.OrderStatusCode })
	orderStatusCode!: constants.OrderStatusCode | null;

	@GandalfProperty({ designType: Number })
	orderStatusId!: number | null;

	@GandalfProperty({ designType: Number })
	parentHistoryId!: number | null;

	@GandalfProperty({ designType: Date })
	startDate!: Date | null;

	@GandalfProperty({ designType: String })
	statusLabel!: string | null;

	@GandalfProperty({ designType: String })
	updatedBy!: string | null;

}
